module.exports = "https://web-assets.ifttt.com/packs/media/header/home-icon-22a44347.svg";